import { darken } from 'polished';
import styled from 'styled-components';
import { Colors } from '../../../ui';
import { Roundings, Shadows } from '../../../ui/Standards';

export const EditorModeWidgetFrame = styled.div`
    position: absolute;
    bottom: 0;
    left: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: .5rem;
    transform: translate(-50%, .75rem);
    pointer-events: none;

    & > * {
        pointer-events: all;
    }
`;

export const EditorModeWidgetButton = styled.div<{ color: string }>`
    display: flex;
    align-items: center;
    justify-content: space-between;
    white-space: nowrap;
    min-width: 15rem;
    gap: .5rem;
    padding: .375rem 1rem;
    font-weight: 450;
    color: ${p => p.color};
    border: solid .125rem ${p => p.color};
    box-shadow: ${Shadows.sm};
    background: white;
    border-radius: ${Roundings.lg};
    cursor: pointer;
    user-select: none;

    &:hover {
        color: ${p => darken(.1, p.color)};
        border: solid .125rem ${p => darken(.05, p.color)};
        background: #fdfdfd;
    }

    &:active {
        color: ${p => darken(.2, p.color)};
        border: solid .125rem ${p => darken(.1, p.color)};
        background: #fbfbfb;
    }
`;

export const EditorModeWidgetContent = styled.div`
    position: relative;
    border: solid .125rem ${Colors.border};
    box-shadow: ${Shadows.sm};
    background: white;
    border-radius: ${Roundings.lg};
`;
